
        import 'FilterPanel.553dc81.css-module'
        export default {"FilterPanel":"FilterPanel_FilterPanel_553dc81"}
    